module.exports = __webpack_public_path__ + "img/need_fast.c7ff5f98.svg";